// Address Enums ---------------------------------------------------------------------------------------------------------------------------

export enum AddressFields {
  Address = 'address',
  AddressType = 'address_type',
  AdminArea1 = 'admin_area_1',
  AdminArea2 = 'admin_area_2',
  Country = 'country',
  CreatedAt = 'created_at',
  Id = 'id',
  Latitude = 'latitude',
  Locality = 'locality',
  Longitude = 'longitude',
  NormalAddress = 'normal_address',
  PlaceId = 'place_id',
  PostalAddress = 'postal_address',
  PostalCode = 'postal_code',
  Route = 'route',
  StreetNumber = 'street_number',
  SubPremise = 'sub_premise',
  UpdatedAt = 'updated_at',
}

export enum AddressTypes {
  NormalAddress = 1,
  PostalAddress = 2,
}

// Address Constants -----------------------------------------------------------------------------------------------------------------------

export const AddressCoreFields = [AddressFields.Route, AddressFields.Locality, AddressFields.AdminArea1, AddressFields.PostalCode, AddressFields.Country] as const;

// Address Interfaces ----------------------------------------------------------------------------------------------------------------------

export interface AddressCrud {
  [AddressFields.AddressType]: number;
  [AddressFields.AdminArea1]?: string | null;
  [AddressFields.AdminArea2]?: string | null;
  [AddressFields.Country]?: string | null;
  [AddressFields.Id]?: number;
  [AddressFields.Latitude]?: number | null;
  [AddressFields.Locality]?: string | null;
  [AddressFields.Longitude]?: number | null;
  [AddressFields.PlaceId]?: string | null;
  [AddressFields.PostalCode]?: string | null;
  [AddressFields.Route]?: string | null;
  [AddressFields.StreetNumber]?: string | null;
  [AddressFields.SubPremise]?: string | null;
}
